import {MaterialId, MaterialValue} from './data';

export const ETHANOL_80_PCT: MaterialValue = {
  kind: 'material',
  id: '{"id":"ethanol_solution_80%"}' as unknown as MaterialId,
  label: 'Ethanol solution (80%)',
  amount: {kind: 'concentration', number: 80, unit: '%'},
  contents: [],
  tags: {},
};

export const ETHANOL_100_PCT: MaterialValue = {
  kind: 'material',
  id: '{"label":"Ethanol (100%)","amount":"100%","contents":[],"tags":{}}' as unknown as MaterialId,
  label: 'Ethanol (100%)',
  amount: {kind: 'concentration', number: 100, unit: '%'},
  contents: [],
  tags: {},
};

export const SPRI_MAGNETIC_BEADS: MaterialValue = {
  kind: 'material',
  id: '{"label":"SLS magnetic beads for DNA purification","amount":"1x","contents":[],"tags":{}}' as unknown as MaterialId,
  label: 'SLS magnetic beads for DNA purification',
  amount: {kind: 'concentration', number: 1, unit: 'x'},
  contents: [],
  tags: {},
};

export const WATER: MaterialValue = {
  kind: 'material',
  id: '{"label":"Nuclease-Free Water","amount":"1x","contents":[],"tags":{}}' as unknown as MaterialId,
  label: 'Nuclease-Free Water',
  amount: {kind: 'concentration', number: 1, unit: 'x'},
  contents: [],
  tags: {},
};
